import { useTextPostStateContext } from './usePostCreationContext';

export const useTextPostForm = () => {
  const [state, dispatch] = useTextPostStateContext();

  return [state.form, dispatch] as const;
};